import { token } from "@may-i/mash-design-system";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { BranchSelector } from "./BranchSelector";
import { LanguageSelector } from "./LanguageSelector";
import { UserMenu } from "./UserMenu";
import { VersionStats } from "./VersionStats";

const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--gnb-height);
  padding: 0 24px;
  border-bottom: 1px solid ${token("colors.border.outline")};
  background-color: ${token("colors.gray.white")};
  flex-shrink: 0;
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const RightGroup = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoImage = styled.img`
  height: 24px;
  width: auto;
  cursor: pointer;
  margin-right: 8px;
`;

export function GNB() {
  const navigate = useNavigate();

  return (
    <Nav>
      <LeftGroup>
        <LogoImage
          src="/assets/images/mst-logo.svg"
          alt="mST Logo"
          onClick={() => navigate("/")}
        />
        <BranchSelector />
        <VersionStats />
      </LeftGroup>
      <RightGroup>
        <LanguageSelector />
        <UserMenu />
      </RightGroup>
    </Nav>
  );
}
